import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 5H20M4 9H13M6 19.25H9C9.69036 19.25 10.25 18.6904 10.25 18V15C10.25 14.3096 9.69036 13.75 9 13.75H6C5.30964 13.75 4.75 14.3096 4.75 15V18C4.75 18.6904 5.30964 19.25 6 19.25ZM15 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V15C19.25 14.3096 18.6904 13.75 18 13.75H15C14.3096 13.75 13.75 14.3096 13.75 15V18C13.75 18.6904 14.3096 19.25 15 19.25Z" />
	</SVG>
);
